<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
          >
            <h1 class="title">
              About Us
            </h1>
            <h4>
              Meet the amazing team behind this project and find out more about
              how we work.
            </h4>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section pb-0">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-small-size-100 mx-auto">
              <h2>Objectives of AER</h2>
                <p>The objectives of the ASEAN Register are as follows:</p>
                <ol>
                  <li>
                    To promote recognition of ASEAN engineering team within and outside ASEAN;
                  </li>
                  <li>
                      To safeguard and promote the professional interest of engineers, engineering technologists and technicians;
                  </li>
                  <li>
                      To foster high standards of formation and professional practice and regularly review them;
                  </li>
                  <li>
                      To promote cultural and professional links among members of the engineering profession within ASEAN;
                  </li>
                  <li>
                      To enhance wealth of ASEAN countries;
                  </li>
                  <li>
                      To provide sufficient data regarding the formation of an individual engineers, engineering technologists and technicians for the benefit of prospective employers;
                  </li>
                  <li>
                      To encourage a continuous updating of the quality of engineers, engineering technologists and technicians by setting, monitoring and reviewing standards.
                  </li>
                </ol>
              <p>
                In pursuit of these aims, AFEO shall maintain the Register into which individuals may be admitted provided they meet the specified minimum requirements.
              </p>
              <h2>AER Historical Background</h2>
                <p>
                    The idea to set up the ASEAN Engineering Register was first mooted at the
                14th AFEO Governing Board meeting held in Air Keroh, Melaka, Malaysia
                on 25 November 1996. The meeting agreed to set up an ASEAN Engineers
                Working Group to collect, tabulate and disseminate information on the
                education systems, engineering curriculum, recognition of degrees and
                qualifications, accreditation of qualifications and requirements for
                achieving professional engineer status of each ASEAN Institutions.
                </p>
                <p>
                    Philippines Technological Council (PTC) was nominated and appointed
                    the permanent Chairmanship to prepare the findings and to standardise
                    the level of engineering competence required for attainment of professional
                    engineer status with relation to the regulation of each of the ASEAN countries.
                </p>
                <p>
                    At the 15th meeting the following year (27 November 1997) in Chiangmai,
                    Thailand, the AFEO Governing Board noted the benchmarking of the APEC
                    Engineer Register and agreed that IEM should host a forum on the ASEAN
                    Engineer and to look into avenue for the AFEO Engineers in APEC. As PTC
                    could not progress due to change over of Chairmanship and lack of
                    information on the procedure for the set up of ASEAN Engineering Register,
                    IEM undertook to finalise this issue.
                </p>
                <p>
                    IEM at the 16th AFEO Governing Board meeting on 23 November 1998 in
                    Clarkfield,  Angeles City, Philippines, tabled the first working paper
                    on the Guidelines for the setting up of the ASEAN Engineer Register.
                    The paper detailed the objective, concept, minimum requirements and operation
                    of an ASEAN Engineer Register. Procedure of application and registration was
                    also included in this presentation. The report was an output of the ASEAN
                    Engineers Roundtable meeting. At the 16th CAFEO Workshop Forum (held a day
                    before the governing board meeting) proposal was made to include Architects
                    into the Register and be named as ASEAN Engineering/Architect Register.
                </p>
                <p>
                    The AFEO Governing Board approved in principle a meeting amongst the
                    Institution on the development of ASEAN Engineer in March 1999 to be hosted
                    by IEM to consider the standing or status of AFEO Engineers in ASEAN. The
                    AFEO Governing Board also agreed to establish the ASEAN Engineer/Architect
                    Register and AFEO Board members unanimously agreed that IEM be appointed the
                    Secretariat to maintain the Register.
                </p>
                <p>
                    The first text of the Register was prepared and finalised on 8 January 1999.
                    The text was amended and presented to IEM Council the same month. A letter
                    was sent to Wisma Putra to inform the Ministry of Foreign Affairs of the setting
                    up and formation of the ASEAN Engineer. A progress report on the ASEAN
                    Engineering/Architects Register was tabled eventually on 4 May 1999 to IEM
                    Excomm for approval to be tabled to AFEO Board meeting later part of the
                    year.
                </p>
                <h3>Set Up</h3>
                <br />
                <p>
                    After the 16th meeting of the AFEO Board, a special committee has been
                    set up in December 1998 and to be spread-headed by The Institution of
                    Engineers, Malaysia to proceed with the formation of the Register.
                    Several meetings were held to design an application form. In February
                    1999  the forms were issued to members of The Institution of Engineers,
                    Malaysia to test its response. Lots of inquiries were received and by
                    then 50 IEM members were the first batch to sign up for the Register.
                    From the feedback,  the application form was amended and a second trial
                    run took place in July 1999.
                </p>
                <p>
                    At the 17th AFEO Governing Board meeting held in Singapore on 19 November
                    1999, the AFEO Governing Board supported the urgent need to start the
                    Register using the IEM model as the guide.
                </p>
                <p>
                    At the 18th AFEO Board meeting in  Hanoi, Vietnam on 24 November 2000.
                    PTC was appointed to remain as the Chairman of ASEAN Engineering Register
                    whilst the IEM was appointed the Secretariat responsible for its
                    implementation and maintenance. It was agreed at this meeting that it
                    should be solely a register for Engineers and the name was altered to
                    ASEAN Engineer Register. Each AFEO member organisation was requested to
                    establish a National Monitoring Committee (NMC) made up of a maximum of
                    five (5) members to undertake the role of examining each application
                    before it was submitted to the ASEAN Engineering Register Commission meeting
                    for approval.
                </p>
                <p>
                    During 19th AFEO Governing Board meeting on 23 October 2001, the AFEO
                    Board agreed that the AER will be operating as a Trade Register that
                    will provide a complete database of practicing engineers within the
                    ASEAN countries.  At this date 240 engineers all from IEM had been
                    registered. The AFEO Heads at this meeting in Brunei Darussalam also
                    officially signed the AER Guidelines after some minor amendments were
                    made to the draft.
                </p>
                <p>
                  The AER Secretariat was set up on 3rd September 2002. Since 23rd October 2003, a permanent AFEO Secretariat has also established.
                </p>
                <p>
                  The ASEAN Federation of Engineering Organisations (AFEO) Governing Board at its meeting in Vientiane, Lao PDR in June 2011, have agreed to expand the ASEAN Engineers Register (AER) into the ASEAN Engineering Register (AER) to include the registration of the entire engineering team comprising the Engineers, Engineering Technologists, Technicians and related Associates.
                </p>
                <h3>About ASEAN Federation of Engineering Organisations (AFEO)</h3>
                <br />
                <p>
                  The ASEAN Federation of Engineering Organisations (AFEO) is a non-governmental body. Its members are the engineering institutions and organisations of ASEAN countries with the following main objectives:
                </p>
                <ul>
                  <li>To promote goodwill and mutual understanding</li>
                  <li>To establish and develop an ASEAN baseline standard for the engineering profession with the objective of facilitating the mobility of the engineers within the ASEAN countries.</li>
                </ul>
                <p>
                  <a href="http://www.afeo.org" target="_blank">Learn more about AFEO</a>
                </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";

export default {
    components: {
    },
    mixins: [Mixins.HeaderImage],
    bodyClass: "about-us",
    data() {
        return {
            speciality: "",
            name: null,
            email: null,
            image: require("@/assets/img/bg9.jpg"),
            aboutTeam: {
                aboutTeam1: require("@/assets/img/faces/marc.jpg"),
                aboutTeam2: require("@/assets/img/faces/kendall.jpg"),
                aboutTeam3: require("@/assets/img/faces/christian.jpg"),
                aboutTeam4: require("@/assets/img/faces/avatar.jpg")
            },
            aboutOffice: {
                aboutOffice1: require("@/assets/img/examples/office2.jpg"),
                aboutOffice2: require("@/assets/img/examples/office4.jpg"),
                aboutOffice3: require("@/assets/img/examples/office3.jpg"),
                aboutOffice4: require("@/assets/img/examples/office5.jpg"),
                aboutOffice5: require("@/assets/img/examples/office1.jpg")
            }
        };
    }
};
</script>

<style lang="scss" scoped>
.mt-2 {
  margin-top: 1.5rem;
}
</style>
